import { Message } from 'semantic-ui-react';
import styled from '@emotion/styled';

const RelationsMessageContainer = styled.div`
  width: 80vw;
  margin: 40px auto;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 32px 24px;
`;

const RelationsMessage = ({ header, message }) => {
  return (
    <RelationsMessageContainer>
      <Message positive>
        <Message.Header>{header}</Message.Header>
        <p>{message}</p>
      </Message>
    </RelationsMessageContainer>
  );
};

export default RelationsMessage;
